@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.myAccountButton {
  border: none;
  margin-bottom: 10px;
  white-space: nowrap;
  color: var(--white);
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: Bold;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;


  @include breakpoints.mobile-large {
    white-space: inherit;
  }

  @include breakpoints.desktop {
    margin-right: 50px;
  }
}

.subButtons {
  white-space: normal;
  position: absolute;
  top: 60px;
  right: 0;
  display: flex;
  flex-direction: column;
  column-count: 1;
  z-index: var(--modal-overlay);
  width: 100%;
  max-width: 600px;
  font-family: typography.$font-mont;

  @include breakpoints.mobile-large {
    right: 0;
    width: 100%;
    max-width: 180px;
  }

  @include breakpoints.tablet {
    right: 0;
    width: 100%;
    max-width: 180px;
  }

  @include breakpoints.desktop {
    right: 60px;
  }
}


.subButtonsCIAM {
  white-space: normal;
  position: absolute;
  top: 60px;
  right: 0;
  display: flex;
  flex-direction: column;
  column-count: 1;
  z-index: var(--modal-overlay);
  width: 100%;
  max-width: 600px;

  @include breakpoints.mobile-large {
    right: 0;
    width: 100%;
    max-width: 180px;
  }

  @include breakpoints.tablet {
    right: 0;
    width: 100%;
    max-width: 180px;
  }

  @include breakpoints.desktop {
    right: 20px;
  }
}

.subButton {
  white-space: normal;
  border: none;
  background-color: var(--blue-01);
  color: var(--white);
  padding: 10px 15px;
  cursor: pointer;
  margin-top: -1px;
  outline: none;

  z-index: var(--modal-overlay);
  width: 100%;
  max-width: 600px;

  &:hover {
    background-color: var(--black);
  }
}

.middleButton {
  border-top: 1px solid var(--gray-04-at-30);
  border-right: 0;
}

.bottomButton {
  border-top: 1px solid var(--gray-04-at-30);
  border-radius: 0 0 4px 4px;
}
